<template>
    <div class='parentsDetail conParentDetail'>
        <p class="topTheme">{{data.interviewTime}}-家长交流-{{data.interviewTheme}}</p>
        <div class="lineBox">
            <CircleName name="学生主要问题" ></CircleName>
            <el-input type="textarea" :value="data.mainProblem"  readonly :rows="4" ></el-input>
        </div>
        <div class="lineBox">
            <CircleName name="咨询要点记录"></CircleName>
            <el-input type="textarea" :value="data.consultantPoints" readonly :rows="4" ></el-input>
        </div>
        <div class="lineBox">
            <CircleName name="建议解决对策"></CircleName>
            <el-input type="textarea" :value="data.recommendSolution" readonly :rows="4" ></el-input>
        </div>
        <div class="summary">
            <SummaryTitle title='咨询记录'/>
            <el-input type="textarea" :value="data.consultSummary" readonly :rows="5" ></el-input>
        </div>
    </div>
</template>
<script>
import CircleName from '@/components/consultant/CircleName.vue';
import SummaryTitle from '@/components/consultant/SummaryTitle.vue';
export default {
    name: "parentsDetail",
    props: ['data'],
    components: {
        CircleName,
        SummaryTitle
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {

    },
}
</script>

<style scoped lang="less">
.parentsDetail {
    padding: 6px 30px 30px 30px;
    background-color: #fff;
    .topTheme {
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        margin-bottom: 15px;
    }
    .lineBox {
        margin-bottom: 32px;
    }
}
</style>
<style lang="less">
.conParentDetail {
    .el-textarea {
        padding-top: 16px;
        textarea {
            background: rgba(61, 144, 246, 0.2);
            border-radius: 4px;
            border: none;
        }
    }
}
</style>